import * as yup from "yup"
import moment from "moment"

export const TPAFormSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    feeType: yup.string().required("Fee type is required"),
    feeAmount: yup
        .number()
        .typeError("Fee amount must be a number")
        .required("Fee amount is required")
        .min(0, "Fee amount must be non-negative"),
    contactName: yup.string().required("Contact name is required"),
    contactEmail: yup.string()
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email format")
        .required("Contact email is required"),
    contactPhone: yup.string()
        .matches(/^\+1[0-9]{10}$/, 'Phone number must start with +1 followed by 10 digits')
        .required("Contact phone is required"),
    description: yup.string().nullable(),
})


export const TPAConfigFormSchema = yup.object().shape({
    tpa: yup.string().required("TPA is required"),
    claimType: yup.string().required("Claim type is required"),
    communicationChannel: yup.string().required("Communication channel is required"),
    startDate: yup
        .string()
        .required("Start date is required"),
    endDate: yup
        .string()
        .transform(value => value === "" ? null : value)
        .nullable()
        .test("end-after-start", "End date cannot be before start date", function (value) {
            const { startDate } = this.parent
            if (!value || !startDate) return true
            const start = moment(startDate, "YYYY-MM-DD")
            const end = moment(value, "YYYY-MM-DD")
            return end.isSameOrAfter(start)
        }),
    lineOfBusiness: yup.string().required("Line of business is required"),
})
